const { defineCustomElement } = require('vue');
import App from './App.ce.vue';

customElements.define('hr-tp-button', defineCustomElement(App));
